// The hand-off whose shared text is lit on one board's cards: the card it is
// lit on (`key`: the card's session, null for the board's own trace), the
// strings it shares (`follow`: one a line, as a hand-off card names them) and
// the cells that carry them. A dock reading a cell of the board lights it or
// puts it out, wherever that dock is drawn; the board rings those cells, as a
// trace's lanes view rings its own.
export const NO_LIGHT = { get: () => null, subscribe: () => () => {}, toggle: () => {} };

export function createHandoffLight() {
  let lit = null;
  const subs = new Set();
  return {
    get: () => lit,
    subscribe: (fn) => {
      subs.add(fn);
      return () => { subs.delete(fn); };
    },
    // `cells`: the card's cells that carry them ({ lane, turn }), found by the
    // dock from the card's trace; `cellsOf` finds them again from the card's
    // record as it stands (its turns, its lanes), for a board whose card has
    // read more of it since. The same hand-off on the same card again puts it
    // out.
    toggle: (key, follow, cells = [], cellsOf = null) => {
      const k = key ?? null;
      lit = !follow || (lit && lit.key === k && lit.follow === follow) ? null : { key: k, follow, cells, cellsOf };
      for (const fn of [...subs]) fn();
    },
  };
}

// The hand-off lit on a card, for that card's dock: its strings, or null.
export function litOn(lit, key) {
  return lit && lit.key === (key ?? null) ? lit.follow : null;
}
